/**
 * Created by Pierrot on 08/10/2014.
 */
'use strict';
import * as _ from 'lodash';

module.exports = function (angular) {
  return {
    unsafe:function($sce) { return $sce.trustAsHtml; }
  };
};